// extracted by mini-css-extract-plugin
module.exports = {"root":"CardSliderItem_root__V5Rnq","media":"CardSliderItem_media__ViF1M"};